export default function log(text, color) {
    var d = new Date();

    console.log(`${d.getHours()}:${d.getMinutes()}:${d.getSeconds()} %c ${text}`, `color: ${color}`);
}
